import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/feature/SEO';
import ImpactHeroSection from './components/ImpactHeroSection';
import OxygenChallengeSection from './components/OxygenChallengeSection';
import RoadmapSection from './components/ImpactMetricsGrid';
import MeasurementSection from './components/TransparencySection';
import SupportCallSection from './components/SupportCallSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/impact#webpage`,
      url: `${siteUrl}/impact`,
      name: 'Our Impact | Families Reached & Lives Changed – Diatomic Life Foundation',
      description:
        'See the measurable impact of Diatomic Life Foundation — families reached, oxygen kits distributed, and communities empowered through transparent reporting.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
          { '@type': 'ListItem', position: 2, name: 'Impact', item: `${siteUrl}/impact` },
        ],
      },
    },
    {
      '@type': 'Report',
      '@id': `${siteUrl}/impact#report`,
      name: 'Diatomic Life Foundation Impact Report',
      url: `${siteUrl}/impact`,
      about: { '@id': `${siteUrl}/#organization` },
      description: 'Transparent reporting on oxygen kits distributed, families supported, and communities empowered by Diatomic Life Foundation.',
      publisher: { '@id': `${siteUrl}/#organization` },
      datePublished: '2025-01-01',
      dateModified: new Date().toISOString().split('T')[0],
    },
  ],
};

export default function Impact() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Our Impact | Families Reached & Lives Changed – Diatomic Life Foundation"
        description="Discover the real-world impact of Diatomic Life Foundation — oxygen kits distributed, families supported, and transparent reporting on every donation received."
        keywords="oxygen impact, NGO impact report, families helped, Diatomic Life Foundation impact"
        canonical={`${siteUrl}/impact`}
        schemaJson={schema}
      />
      <Header />
      <main>
        <ImpactHeroSection />
        <OxygenChallengeSection />
        <RoadmapSection />
        <MeasurementSection />
        <SupportCallSection />
      </main>
      <Footer />
    </div>
  );
}
